import { jsxs as Se, jsx as g } from "react/jsx-runtime";
import { c as he } from "./index-65016bfa.mjs";
import rt, { useMemo as kt, useRef as Z, useEffect as le, useState as Ke, forwardRef as Tt, useLayoutEffect as $t } from "react";
import x, { css as Y, styled as Mt } from "styled-components";
import { useTheme as Wt, ThemeName as vt } from "@fcamna/shared-component-foundations";
import { u as xt } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { u as Et } from "./useWindowSize-88e90e04.mjs";
import { I as be, H as Pt } from "./helperText-d9646f54.mjs";
import { S as bt } from "./screenReaderOnly-fd82ed96.mjs";
import { u as Rt } from "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "./table.js";
import { u as Bt } from "./uniqueId-321287e8.mjs";
import { g as yt } from "./getElementPosition-a8642645.mjs";
import { ButtonV1 as Yt } from "./buttonV1.js";
import { IconButton as It } from "./iconButton.js";
import { Icon as gt } from "./icon.js";
import { TextInput as Ft } from "./textInput.js";
import "./_commonjsHelpers-92157f1b.mjs";
import "react-dom";
import "./Aria-f5e019e2.mjs";
import "./combineRefs-90f27925.mjs";
import "@fcamna/shared-icons";
import "./button.js";
import "./label-33699561.mjs";
import "./popupTip.js";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./closeButton.js";
import "./divider.js";
import "./focusTrap.js";
import "./useClient-0bbce34e.mjs";
import "./link.js";
import "./tooltip.js";
const Ut = 100, Vt = 50, De = "SINGLE_DATE", Ae = "RANGE", Le = "MUTLI_DATE", Fe = (e, n) => Array.from(Array(e).keys()).map((t) => ({
  value: t + 1,
  id: `${n}-${t}`
})), ie = (e, n) => !e || !n ? !1 : e.day === n.day && e.month === n.month && e.year === n.year, we = (e) => ({ ...e }), Ot = (e) => JSON.parse(JSON.stringify(e, (n, t) => typeof t > "u" ? null : t)), at = (e, n) => {
  const t = n === "NEXT" ? 1 : -1;
  let r = e.month + t, o = e.year;
  return r < 1 && (r = 12, o -= 1), r > 12 && (r = 1, o += 1), { year: o, month: r, day: 1 };
}, Ne = (e, n) => Object.prototype.hasOwnProperty.call(e || {}, n), Ce = (e) => {
  if (Array.isArray(e))
    return Le;
  if (Ne(e, "from") && Ne(e, "to"))
    return Ae;
  if (!e || Ne(e, "year") && Ne(e, "month") && Ne(e, "day") || typeof e == "string")
    return De;
  throw new TypeError("The passed value is malformed! Please make sure you're using one of the valid value types for date picker.");
}, Kt = (e) => e && e[0].toUpperCase() + e.slice(1) || "", Oe = (e, n = !1) => {
  const t = e.replace(new RegExp("/", "g"), "").replace(new RegExp(" ", "g"), "");
  if (!/^\d+$/g.test(t))
    return "";
  let r = t.substring(0, 2), o = t.substring(2, 4), c = t.substring(4, 8);
  r && (r.length === 2 && +r == 0 ? r = "01" : +r > 12 && (r = `0${r.substring(0, 1)}`, o = t.substring(1, 3), c = t.substring(3, 7))), o && (o.length === 2 && +o == 0 ? o = "01" : +o > 31 && (c = o.substring(1, 2) + c.substring(0, 3), o = `0${o.substring(0, 1)}`));
  const p = `${r}${o && ` / ${o}`}${c && ` / ${c}`}`;
  return n ? { month: r, day: o, year: c } : p;
}, st = (e, n, t, r = !0) => {
  if (!t)
    return "";
  const o = new Date(t.year, t.month - 1, t.day), c = {
    month: "2-digit",
    day: "2-digit",
    year: "numeric"
  }, p = e || c;
  return o.toLocaleDateString(r ? n : "en-US", r ? p : c).replace(new RegExp("/", "g"), " / ");
}, Ht = (e, n, t, r, o) => {
  if (!o.from || !o.to)
    return "";
  const { from: c, to: p } = o, y = new Date(c.year, c.month - 1, c.day), D = new Intl.DateTimeFormat("en-US").format(y).toString(), w = new Date(p.year, p.month - 1, p.day), E = new Intl.DateTimeFormat("en-US").format(w).toString();
  return `${t} ${D} ${r} ${E}`;
}, St = (e, n) => {
  if (!e)
    return { formatted: "", default: "", native: /* @__PURE__ */ new Date() };
  const { month: t, day: r, year: o } = e, c = st(n, "en-US", { month: t, day: r, year: o }), p = st(null, "en-US", { month: t, day: r, year: o });
  return { formatted: c, default: p, native: new Date(o, t - 1, r) };
}, ct = (e, n = !1) => {
  const { month: t, day: r, year: o } = Oe(e, !0);
  if (t && r && o && o.length === 4 && +o > 1e3) {
    const c = new Date(o, t - 1, r);
    return c.getMonth() + 1 !== parseInt(t) || c.getDate() !== parseInt(r) || c.getFullYear() !== parseInt(o) ? null : n ? { month: +t, day: +r, year: +o } : { month: t, day: r, year: o };
  }
  return null;
}, qt = {
  weekStartingIndex: 0,
  getToday(e) {
    return e;
  },
  toNativeDate(e) {
    return new Date(e.year, e.month - 1, e.day);
  },
  getMonthLength(e) {
    return new Date(e.year, e.month, 0).getDate();
  },
  transformDigit(e) {
    return e;
  },
  nextMonth: "Next Month",
  previousMonth: "Previous Month",
  openMonthSelector: "Open Month Selector",
  openYearSelector: "Open Year Selector",
  closeMonthSelector: "Close Month Selector",
  closeYearSelector: "Close Year Selector",
  from: "from",
  to: "to",
  defaultPlaceholder: "MM / DD / YYYY",
  defaultLabel: "Select Date",
  digitSeparator: ",",
  yearLetterSkip: 0,
  isRtl: !1
}, Xt = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], Gt = (e = "en-US", n = "long") => {
  const t = new Intl.DateTimeFormat(e, {
    month: n,
    timeZone: "America/Los_Angeles"
  }).format;
  return Xt.map((r) => Kt(t(new Date(Date.UTC(2021, (r + 1) % 12)))));
}, zt = [0, 1, 2, 3, 4, 5, 6], Jt = (e = "es-US", n = "long") => {
  const t = new Intl.DateTimeFormat(e, {
    weekday: n,
    timeZone: "America/Los_Angeles"
  }).format;
  return zt.map((r) => {
    const o = t(new Date(Date.UTC(2021, 10, r + 1)));
    return {
      name: t(new Date(Date.UTC(2021, 10, r + 1))),
      short: o.charAt(0).toUpperCase(),
      isWeekend: r === 0 || r === 6
    };
  });
}, Nt = (e) => typeof e == "string" ? {
  months: Gt(e),
  weekDays: Jt(e),
  ...qt
} : e, Zt = (e = "en_US") => {
  const {
    months: n,
    getToday: t,
    toNativeDate: r,
    getMonthLength: o,
    weekStartingIndex: c,
    transformDigit: p
  } = typeof e == "string" ? Nt(e) : e;
  return {
    getToday: () => {
      const l = /* @__PURE__ */ new Date(), S = l.getFullYear(), C = l.getMonth() + 1, P = l.getDate();
      return t({ year: S, month: C, day: P });
    },
    getMonthName: (l) => n[l - 1],
    getMonthNumber: (l) => n.indexOf(l) + 1,
    getMonthLength: o,
    getMonthFirstWeekday: (l) => (r({ ...l, day: 1 }).getDay() + c) % 7,
    isBeforeDate: (l, S) => !l || !S ? !1 : r(l) < r(S),
    checkDayInDayRange: ({ day: l, from: S, to: C }) => {
      if (!l || !S || !C)
        return !1;
      const P = r(l), I = r(S), i = r(C);
      return P > I && P < i;
    },
    getLanguageDigits: p
  };
}, Te = (e) => kt(() => Zt(e), [e]), $e = (e) => kt(() => Nt(e), [e]), it = (e, n) => e ? e.children[n] : null, Ue = (e) => e && (e.hasAttribute("aria-hidden") ? null : e), Ve = (e, n) => {
  e.preventDefault(), n && (n.setAttribute("tabindex", "0"), n.focus());
}, Dt = (e, n) => it(n, Array.from(e.parentElement.children).indexOf(e)), dt = (e, { allowVerticalArrows: n }) => {
  const { activeElement: t } = document, { nextSibling: r, previousSibling: o } = t.parentElement, c = Ue(t.nextSibling || it(r, 0)), p = o ? o.children.length - 1 : 0, y = Ue(t.previousSibling || it(o, p)), D = Ue(Dt(t, r)), w = Ue(Dt(t, o));
  switch (t.dataset.isDefaultSelectable === "true" || (t.tabIndex = "-1"), e.key) {
    case "ArrowRight":
      Ve(e, c);
      break;
    case "ArrowLeft":
      Ve(e, y);
      break;
    case "ArrowDown":
      n && Ve(e, D);
      break;
    case "ArrowUp":
      n && Ve(e, w);
      break;
  }
}, Lt = ({ parent: e, isInitialActiveChild: n, activeDate: t, monthChangeDirection: r }) => {
  if (!e)
    return n ? t : at(t, "NEXT");
  const o = e.children[n ? 0 : 1];
  return o.classList.contains("-shown") || o.classList.contains("-shownAnimated") ? t : at(t, r);
}, At = ({ parent: e, direction: n }) => {
  const t = Array.from(e.children), r = t.find((y) => y.classList.contains("-shown")), o = t.find((y) => y !== r), c = n === "NEXT", p = (y) => y ? "-hiddenNext" : "-hiddenPrevious";
  o.style.transition = "none", r.style.transition = "", r.classList.remove(p(c)), r.classList.add(p(!c)), r.classList.remove("-shown"), r.setAttribute("aria-hidden", "true"), o.classList.remove(p(!c)), o.classList.add(p(c)), o.classList.add("-shownAnimated");
}, lt = ({ target: e }) => {
  e.classList.remove("-hiddenNext"), e.classList.remove("-hiddenPrevious"), e.classList.replace("-shownAnimated", "-shown"), e.setAttribute("aria-hidden", "false");
}, Qt = x.div`
  &.Calendar__sectionWrapper {
    ${({
  theme: {
    components: { datePicker: e }
  }
}) => Y(e.StyledCalendarSectionWrapper)};
  }
`, _t = x.div`
  &.Calendar__section {
    ${({
  theme: {
    components: { datePicker: e }
  }
}) => Y(e.StyledCalendarSection)};
  }
`, jt = x.div`
  &.Calendar__day {
    ${({
  theme: {
    components: { datePicker: e }
  }
}) => Y(e.StyledCalendarDay)};
  }
`, en = x.div`
  &.Calendar__weekRow {
    ${({
  theme: {
    components: { datePicker: e }
  }
}) => Y(e.StyledCalendarWeekRow)};
  }
`, tn = ({
  activeDate: e,
  value: n,
  monthChangeDirection: t,
  onSlideChange: r,
  disabledDays: o = [],
  onDisabledDayError: c,
  minimumDate: p,
  maximumDate: y,
  onChange: D,
  locale: w,
  calendarTodayClassName: E = "",
  calendarSelectedDayClassName: F = "",
  calendarRangeStartClassName: U = "",
  calendarRangeEndClassName: l = "",
  calendarRangeBetweenClassName: S = "",
  shouldHighlightWeekends: C = !1,
  isQuickSelectorOpen: P,
  customDaysClassName: I,
  includeOutOfMonthDays: i,
  selectorStartingYear: b,
  selectorEndingYear: u,
  allowedDates: V,
  weekendDisabled: ee
}) => {
  const N = Z(null), { isRtl: ae, weekDays: te } = $e(w), { getToday: se, isBeforeDate: ne, checkDayInDayRange: ue, getMonthFirstWeekday: re, getMonthLength: O, getLanguageDigits: d, getMonthName: M } = Te(w), $ = se();
  le(() => {
    t && At({
      direction: t,
      parent: N.current
    });
  }, [t]);
  const R = (a) => {
    const h = Ot(n), f = h.from && h.to ? { from: null, to: null } : h, L = f.from ? "to" : "from";
    f[L] = a;
    const { from: m, to: k } = f;
    ne(f.to, f.from) && (f.from = k, f.to = m);
    const H = (T) => ue({
      day: T,
      from: f.from,
      to: f.to
    }), A = o.find(H);
    return A ? (c == null || c(A), n) : f;
  }, me = (a) => {
    const h = n.some((m) => ie(m, a)), f = [...n, a], L = n.filter((m) => !ie(m, a));
    return h ? L : f;
  }, de = (a) => {
    const f = (() => {
      switch (Ce(n)) {
        case De:
          return a;
        case Ae:
          return R(a);
        case Le:
          return me(a);
      }
    })();
    D == null || D(f);
  }, Q = (a) => {
    const h = Ce(n);
    if (h === De)
      return ie(a, n);
    if (h === Le)
      return n.some((f) => ie(f, a));
  }, _ = (a) => {
    const h = ie(a, $), f = Q(a), { from: L, to: m } = n || {}, k = ie(a, L), H = ie(a, m), A = ue({
      day: a,
      from: L,
      to: m
    });
    return {
      isToday: h,
      isSelected: f,
      isStartingDayRange: k,
      isEndingDayRange: H,
      isWithinRange: A
    };
  }, W = (a) => {
    const { isToday: h, isSelected: f, isStartingDayRange: L, isEndingDayRange: m, isWithinRange: k } = _(a), H = I == null ? void 0 : I.find((T) => ie(a, T));
    return "".concat(h && !f ? ` -today ${E}` : "").concat(a.isStandard ? "" : " -blank").concat(a.isWeekend && C ? " -weekend" : "").concat(a.outOfMonth ? " -outofmonth" : "").concat(H ? ` ${H.className}` : "").concat(f ? ` -selected ${F}` : "").concat(L ? ` -selectedStart ${U}` : "").concat(m ? ` -selectedEnd ${l}` : "").concat(k ? ` -selectedBetween ${S}` : "").concat(a.isDisabled ? " -disabled" : "");
  }, K = (a) => {
    const h = Fe(re(a), "starting-blank"), f = Fe(O(a), void 0).map((m) => ({
      ...m,
      isStandard: !0,
      month: a.month,
      year: a.year
    }));
    if (i) {
      const m = {
        ...a,
        month: a.month - 1
      };
      m.month < 1 && (m.month = 12, m.year -= 1);
      const k = re(a) === 0 ? [] : Fe(O(m), void 0).map((J) => ({
        ...J,
        outOfMonth: !0,
        isStandard: !0,
        month: m.month,
        year: m.year
      })).slice(-re(a)), H = {
        ...a,
        month: a.month + 1
      };
      H.month > 12 && (H.month = 1, H.year += 1);
      const A = Fe(O(H), void 0).map((J) => ({
        ...J,
        outOfMonth: !0,
        isStandard: !0,
        month: H.month,
        year: H.year
      })).slice(0, 42 - (k.length + f.length));
      return [...k, ...f, ...A];
    }
    return [...h, ...f];
  }, v = ({ isDisabled: a, ...h }) => {
    a ? c == null || c(h) : de(h);
  }, oe = ({ isOnActiveSlide: a, isStandard: h, isSelected: f, isStartingDayRange: L, isToday: m, day: k }) => {
    if (P || !a || !h)
      return !1;
    if (f || L || m || k === 1)
      return !0;
  }, pe = ({ id: a, value: h, month: f, year: L, isStandard: m, outOfMonth: k }, H) => {
    const A = { day: h, month: f, year: L };
    let T = !1;
    V && V.some((j) => ie(A, j)) && (T = !0);
    const J = o.some((j) => ie(A, j)), He = ne(A, p), We = ne(y, A), qe = L < b || L > u, Xe = m && (He || We || qe), _e = te.some(
      (j, s) => j.isWeekend && s === H
    ), ye = V ? !T : J || Xe || _e && ee, G = W({
      ...A,
      isWeekend: _e,
      isStandard: m,
      isDisabled: ye,
      outOfMonth: k
    }), ve = `${te[H].name}, ${h} ${M(f)} ${L}`, xe = f === e.month, Ee = _(A), { isSelected: Ge, isStartingDayRange: ze, isEndingDayRange: Je, isWithinRange: Ze } = Ee, Pe = oe({
      ...A,
      ...Ee,
      isOnActiveSlide: xe,
      isStandard: m
    }), Re = () => {
      const j = new Date(ve), s = j.getFullYear(), q = j.getMonth() + 1, ce = j.getDate();
      return $.year === s && $.month === q && $.day === ce;
    };
    return /* @__PURE__ */ Se(
      jt,
      {
        tabIndex: Pe ? 0 : -1,
        className: he(["Calendar__day", `${ae ? "-rtl" : "-ltr"}`, G]),
        onClick: () => {
          v({ ...A, isDisabled: ye });
        },
        onKeyDown: ({ key: j }) => {
          j === "Enter" && v({ ...A, isDisabled: ye });
        },
        "aria-disabled": ye,
        ...Re() && { "aria-current": "date" },
        "aria-selected": Ge || ze || Je || Ze,
        ...!m || !xe || P ? { "aria-hidden": !0 } : {},
        role: "gridcell",
        "data-is-default-selectable": Pe,
        children: [
          /* @__PURE__ */ g("span", { "aria-hidden": "true", children: m ? d(h) : "" }),
          /* @__PURE__ */ g(bt, { children: ve })
        ]
      },
      a
    );
  }, fe = (a) => {
    const h = Lt({
      activeDate: e,
      isInitialActiveChild: a,
      monthChangeDirection: t,
      parent: N.current
    }), f = K(h), L = (m) => {
      const k = f.slice(m * 7, m * 7 + 7).map(pe);
      return k.length > 0 ? /* @__PURE__ */ g(
        en,
        {
          className: "Calendar__weekRow",
          role: "row",
          children: k
        },
        String(m)
      ) : "";
    };
    return Array.from(Array(6).keys()).map(L);
  };
  return /* @__PURE__ */ Se(
    Qt,
    {
      ref: N,
      className: "Calendar__sectionWrapper",
      role: "presentation",
      "data-testid": "days-section-wrapper",
      onKeyDown: (a) => {
        dt(a, { allowVerticalArrows: !0 });
      },
      children: [
        /* @__PURE__ */ g(
          _t,
          {
            onAnimationEnd: (a) => {
              lt(a), r();
            },
            className: "Calendar__section -shown",
            role: "rowgroup",
            children: fe(!0)
          }
        ),
        /* @__PURE__ */ g(
          _t,
          {
            onAnimationEnd: (a) => {
              lt(a), r();
            },
            className: "Calendar__section -hiddenNext",
            "aria-hidden": !0,
            role: "rowgroup",
            children: fe(!1)
          }
        )
      ]
    }
  );
}, nn = x.div`
  &.Calendar__header {
    ${({
  theme: {
    components: { datePicker: e }
  }
}) => Y(e.StyledCalenderHeader)};
  }
`, wt = x(It)`
  &.Calendar__header-iconButton {
    ${({
  theme: {
    components: { datePicker: e }
  }
}) => Y(e.StyledIconButton)};
  }
`, rn = x.div`
  &.Calendar__header-monthYearContainer {
    ${({
  theme: {
    components: { datePicker: e }
  }
}) => Y(e.StyledMonthYearContainer)};
  }
`, on = x.div`
  &.Calendar__header-monthYearWrapper {
    ${({
  theme: {
    components: { datePicker: e }
  }
}) => Y(e.StyledMonthYearWrapper)};
  }
`, Ct = x(Yt)`
  &.Calendar__header-ButtonV1 {
    ${({
  theme: {
    components: { datePicker: e }
  }
}) => Y(e.StyledButtonV1)};
  }
`, an = ({
  maximumDate: e,
  minimumDate: n,
  onMonthChange: t,
  activeDate: r,
  monthChangeDirection: o,
  onMonthSelect: c,
  onYearSelect: p,
  isMonthSelectorOpen: y,
  isYearSelectorOpen: D,
  locale: w,
  selectorStartingYear: E,
  selectorEndingYear: F
}) => {
  const U = Z(null), l = Z(null), { getMonthName: S, isBeforeDate: C, getLanguageDigits: P } = Te(w), { nextMonth: I, previousMonth: i, openMonthSelector: b, openYearSelector: u } = $e(w);
  le(() => {
    o && At({
      direction: o,
      parent: l.current
    });
  }, [o]), le(() => {
    var W;
    const d = y || D, M = (W = U == null ? void 0 : U.current) == null ? void 0 : W.querySelector(".Calendar__monthYear.-shown .Calendar__monthText"), $ = M == null ? void 0 : M.nextSibling, R = (K) => K.classList.contains("-activeBackground");
    if (!d && !R(M) && !R($))
      return;
    const de = y || R(M), Q = de ? M : $, _ = de ? $ : M;
    Q == null || Q.classList.toggle("selected"), Q == null || Q.classList.toggle("-activeBackground"), _.classList.toggle("notSelected");
  }, [y, D]);
  const V = (d) => {
    const M = Lt({
      isInitialActiveChild: d,
      monthChangeDirection: o,
      activeDate: r,
      parent: l.current
    }), $ = P(M.year);
    return { month: S(M.month), year: $ };
  }, ee = e && C(e, {
    ...r,
    month: r.month + 1,
    day: 1
  }) || r.year === F && r.month === 12, N = n && (C({ ...r, day: 1 }, n) || ie(n, { ...r, day: 1 })) || r.year === E && r.month === 1, ae = (d) => {
    var $;
    Array.from((($ = l == null ? void 0 : l.current) == null ? void 0 : $.children) ?? []).some(
      (R) => R.classList.contains("-shownAnimated")
    ) || t(d);
  }, te = () => {
    D || c();
  }, se = () => {
    y || p();
  };
  le(() => {
    if (y) {
      const d = document.querySelector(".Calendar__monthSelectorItem.-active"), M = d == null ? void 0 : d.querySelector("button");
      M && setTimeout(() => {
        M.focus();
      }, 100);
    }
    if (D) {
      const d = document.querySelector(".Calendar__yearSelectorItem.-active"), M = d == null ? void 0 : d.querySelector("button");
      M && setTimeout(() => {
        M.focus();
      }, 100);
    }
  }, [y, D]);
  const ne = (d) => {
    (d.key === "Enter" || d.key === " ") && (d.preventDefault(), te());
  }, ue = (d) => {
    (d.key === "Enter" || d.key === " ") && (d.preventDefault(), se());
  }, re = [!0, !1].map((d) => {
    const { month: M, year: $ } = V(d), R = M === S(r.month);
    return /* @__PURE__ */ Se(
      on,
      {
        onAnimationEnd: lt,
        className: he([
          "Calendar__header-monthYearWrapper",
          "Calendar__monthYear",
          `${d ? "-shown" : "-hiddenNext"}`
        ]),
        role: "presentation",
        "aria-hidden": !R,
        children: [
          /* @__PURE__ */ g(
            Ct,
            {
              onClick: () => {
                te();
              },
              variant: "tertiary",
              className: "Calendar__header-ButtonV1 Calendar__monthText",
              onKeyDown: ne,
              tabIndex: R && d ? 0 : -1,
              accessibilityOptions: {
                ariaLabel: y ? "Month Selector" : `${M}, Click here to ${b}`,
                tabIndex: R && d ? 0 : -1,
                ariaExpanded: !!y,
                ariaHidden: !R
              },
              children: M
            }
          ),
          /* @__PURE__ */ g(
            Ct,
            {
              onClick: () => {
                se();
              },
              tabIndex: R && d ? 0 : -1,
              variant: "tertiary",
              className: "Calendar__header-ButtonV1 Calendar__yearText",
              accessibilityOptions: {
                ariaLabel: D ? "Year Selector" : `${$}, Click here to ${u}`,
                tabIndex: R && d ? 0 : -1,
                ariaExpanded: !!D,
                ariaHidden: !R
              },
              onKeyDown: ue,
              children: $
            }
          )
        ]
      },
      String(d)
    );
  }), O = y || D;
  return /* @__PURE__ */ g("div", { role: "row", children: /* @__PURE__ */ Se(
    nn,
    {
      ref: U,
      className: "Calendar__header",
      role: "gridcell",
      children: [
        /* @__PURE__ */ g(
          wt,
          {
            className: he(["Calendar__header-iconButton", { "Calendar__header-iconButton--hidden": O }]),
            iconName: "caretLeft",
            size: "medium",
            accessibilityOptions: {
              ariaHidden: !!O,
              tabIndex: O ? -1 : 0,
              ariaLabel: i,
              ariaDisabled: N
            },
            variant: "tertiary",
            onClick: () => {
              ae("PREVIOUS");
            },
            type: "button",
            disabled: N
          }
        ),
        /* @__PURE__ */ Se(
          rn,
          {
            className: "Calendar__header-monthYearContainer",
            ref: l,
            "data-testid": "month-year-container",
            children: [
              " ",
              re
            ]
          }
        ),
        /* @__PURE__ */ g(
          wt,
          {
            className: he(["Calendar__header-iconButton"]),
            iconName: O ? "cancelClose" : "caretRight",
            size: "medium",
            variant: O ? "ghost" : "tertiary",
            onClick: () => {
              y ? c() : D ? p() : ae("NEXT");
            },
            accessibilityOptions: {
              ariaLabel: O ? "Clear Button" : I,
              ariaDisabled: ee
            },
            type: "button",
            disabled: ee
          }
        )
      ]
    }
  ) });
}, sn = x.div`
  &.Calendar__monthSelectorAnimationWrapper {
    ${({
  theme: {
    components: { datePicker: e }
  }
}) => Y(e.StyledCalendarSelectorAnimationWrapper)};
  }
`, cn = x.div`
  &.Calendar__monthSelectorWrapper {
    ${({
  theme: {
    components: { datePicker: e }
  }
}) => Y(e.StyledCalendarSelectorWrapper)};
  }
`, ln = x.ul`
  &.Calendar__monthSelector {
    ${({
  theme: {
    components: { datePicker: e }
  }
}) => Y(e.StyledCalendarSelector)};
  }
`, dn = x.li`
  &.Calendar__monthSelectorItem {
    ${({
  theme: {
    components: { datePicker: e }
  }
}) => Y(e.StyledCalenderMonthSelectorItem)};
  }
`, un = x.button`
  &.Calendar__monthSelectorItemText {
    ${({
  theme: {
    components: { datePicker: e }
  }
}) => Y(e.StyledCalendarSelectorText)};
  }
`, mn = ({ activeDate: e, maximumDate: n, minimumDate: t, onMonthSelect: r, isOpen: o, locale: c }) => {
  const p = Z(null), y = Z(null);
  le(() => {
    var S, C;
    const l = o ? "add" : "remove";
    (S = y.current) == null || S.classList[l]("-open"), (C = p.current) == null || C.classList[l]("-open");
  }, [o]);
  const { getMonthNumber: D, isBeforeDate: w } = Te(c), { months: E } = $e(c), F = (l) => {
    dt(l, { allowVerticalArrows: !0 });
  }, U = () => E.map((l) => {
    const S = D(l), C = { day: 1, month: S, year: e.year }, P = n && w(n, { ...C, month: S }), I = t && (w({ ...C, month: S + 1 }, t) || ie({ ...C, month: S + 1 }, t)), i = S === e.month;
    return /* @__PURE__ */ g(
      dn,
      {
        className: `Calendar__monthSelectorItem ${i ? "-active" : ""}`,
        children: /* @__PURE__ */ g(
          un,
          {
            tabIndex: i && o ? 0 : -1,
            onClick: () => {
              r(S);
            },
            className: "Calendar__monthSelectorItemText",
            type: "button",
            disabled: P || I,
            "aria-pressed": i,
            "data-is-default-selectable": i,
            children: l.substring(0, 3)
          }
        )
      },
      l
    );
  });
  return /* @__PURE__ */ g(
    sn,
    {
      role: "presentation",
      ref: y,
      className: "Calendar__monthSelectorAnimationWrapper",
      "aria-hidden": !o,
      children: /* @__PURE__ */ g(
        cn,
        {
          role: "presentation",
          "data-testid": "month-selector-wrapper",
          className: "Calendar__monthSelectorWrapper",
          onKeyDown: F,
          children: /* @__PURE__ */ g(
            ln,
            {
              ref: p,
              className: he(["Calendar__monthSelector", "monthSelector"]),
              "data-testid": "month-selector",
              children: U()
            }
          )
        }
      )
    }
  );
}, fn = x.div`
  &.Calendar__yearSelectorAnimationWrapper {
    ${({
  theme: {
    components: { datePicker: e }
  }
}) => Y(e.StyledCalendarSelectorAnimationWrapper)};
  }
`, hn = x.div`
  &.Calendar__yearSelectorWrapper {
    ${({
  theme: {
    components: { datePicker: e }
  }
}) => Y(e.StyledCalendarSelectorWrapper)};
  }
`, pn = x.ul`
  &.Calendar__yearSelector {
    ${({
  theme: {
    components: { datePicker: e }
  }
}) => Y(e.StyledCalendarSelector)};
  }
`, yn = x.li`
  &.Calendar__yearSelectorItem {
    ${({
  theme: {
    components: { datePicker: e }
  }
}) => Y(e.StyledCalendarYearSelectorItem)};
  }
`, gn = x.button`
  &.Calendar__yearSelectorText {
    ${({
  theme: {
    components: { datePicker: e }
  }
}) => Y(e.StyledCalendarSelectorText)};
  }
`, Sn = ({
  isOpen: e,
  activeDate: n,
  onYearSelect: t,
  selectorStartingYear: r = 0,
  selectorEndingYear: o = 0,
  maximumDate: c,
  minimumDate: p,
  locale: y
}) => {
  const D = Z(null), w = Z(null), E = Z(null), { getLanguageDigits: F, getToday: U } = Te(y), l = r || U().year - Ut, S = o || U().year + Vt, C = [];
  for (let i = l; i <= S; i += 1)
    C.push(i);
  return le(() => {
    var u, V, ee, N;
    const i = e ? "add" : "remove", b = (u = D.current) == null ? void 0 : u.querySelector(".Calendar__yearSelectorItem.-active");
    b || console.log(
      "Provided value for year is out of selectable year range. You're probably using a wrong locale prop value or your provided value's locale is different from the date picker locale. Try changing the 'locale' prop or the value you've provided."
    ), (V = E.current) == null || V.classList[i]("-open"), (ee = D.current) == null || ee.classList[i]("-faded"), b && w.current && (w.current.scrollTop = (b == null ? void 0 : b.offsetTop) - (b == null ? void 0 : b.offsetHeight) * 5), (N = w.current) == null || N.classList[i]("-open");
  }, [e]), /* @__PURE__ */ g(
    fn,
    {
      className: "Calendar__yearSelectorAnimationWrapper",
      ref: E,
      role: "presentation",
      "aria-hidden": !e,
      children: /* @__PURE__ */ g(
        hn,
        {
          ref: D,
          className: "Calendar__yearSelectorWrapper",
          role: "presentation",
          "data-testid": "year-selector-wrapper",
          onKeyDown: (i) => {
            dt(i, { allowVerticalArrows: !1 });
          },
          children: /* @__PURE__ */ g(
            pn,
            {
              ref: w,
              className: "Calendar__yearSelector",
              "data-testid": "year-selector",
              children: (() => C.map((i) => {
                const b = c && i > c.year, u = p && i < p.year, V = n.year === i;
                return /* @__PURE__ */ g(
                  yn,
                  {
                    className: he(["Calendar__yearSelectorItem", { "-active": V }]),
                    children: /* @__PURE__ */ g(
                      gn,
                      {
                        tabIndex: V && e ? 0 : -1,
                        className: "Calendar__yearSelectorText",
                        type: "button",
                        onClick: () => {
                          t(i);
                        },
                        disabled: b || u,
                        "aria-pressed": V,
                        "data-is-default-selectable": V,
                        children: F(i)
                      }
                    )
                  },
                  i
                );
              }))()
            }
          )
        }
      )
    }
  );
}, Dn = x.div`
  &.Calendar {
    ${({
  theme: {
    components: { datePicker: e }
  }
}) => e.StyledCalendar};
  }
`, _n = x.div`
  &.Calendar__weekDays {
    ${({
  theme: {
    components: { datePicker: e }
  }
}) => e.StyledCalendarWeekDays};
  }
`, wn = x.abbr`
  &.Calendar__weekDay {
    ${({
  theme: {
    components: { datePicker: e }
  }
}) => e.StyledCalendarWeekDay};
  }
`, Cn = (e, n) => {
  const t = new Date(e.year, e.month - 1, e.day), r = new Date(n.year, n.month - 1, n.day), o = [];
  for (; t <= r; )
    o.push({
      year: t.getFullYear(),
      month: t.getMonth() + 1,
      day: t.getDate()
    }), t.setDate(t.getDate() + 1);
  return o;
}, ot = (e) => {
  if (!e)
    return null;
  const n = [];
  return e.forEach((t) => {
    "from" in t && "to" in t ? n.push(...Cn(t.from, t.to)) : n.push(t);
  }), n;
}, kn = ({
  value: e,
  onChange: n,
  onDisabledDayError: t,
  calendarClassName: r,
  calendarTodayClassName: o,
  calendarSelectedDayClassName: c,
  disabledDays: p,
  minimumDate: y,
  maximumDate: D,
  selectorStartingYear: w,
  selectorEndingYear: E,
  locale: F,
  shouldHighlightWeekends: U,
  customDaysClassName: l,
  includeOutOfMonthDays: S,
  allowedDates: C,
  weekendDisabled: P
}) => {
  const I = Z(null), [i, b] = Ke({
    activeDate: {},
    monthChangeDirection: "",
    isMonthSelectorOpen: !1,
    isYearSelectorOpen: !1
  }), [u, V] = Ke(), ee = (_) => {
    const W = ot(_), K = [];
    W == null || W.forEach((pe) => K.push(new Date(pe.year, pe.month - 1, pe.day).getTime()));
    const v = new Date(Math.min(...K)), oe = new Date(Math.max(...K));
    V({
      minDate: {
        year: v.getFullYear(),
        month: v.getMonth() + 1,
        day: v.getDate()
      },
      maxDate: {
        year: oe.getFullYear(),
        month: oe.getMonth() + 1,
        day: oe.getDate()
      }
    });
  };
  le(() => {
    C ? ee(C) : V({
      minDate: y,
      maxDate: D
    });
  }, [y, D, C]), le(() => {
    var W;
    const _ = (K) => {
      var v;
      K.key === "Tab" && ((v = I == null ? void 0 : I.current) == null || v.classList.remove("-noFocusOutline"));
    };
    return (W = I.current) == null || W.addEventListener("keyup", () => _, !1), () => {
      var K;
      (K = I.current) == null || K.removeEventListener("keyup", () => _, !1);
    };
  });
  const { getToday: N } = Te(F), { weekDays: ae, isRtl: te } = $e(F), se = N(), ne = (_) => () => {
    b({
      ...i,
      [_]: !i[_]
    });
  }, ue = ne("isMonthSelectorOpen"), re = ne("isYearSelectorOpen"), O = () => {
    const _ = Ce(e);
    if (_ === Le && e.length)
      return we(e[0]);
    if (_ === De && e)
      return we(e);
    if (_ === Ae && e.from)
      return we(e.from);
    if (!e) {
      if (C) {
        const W = ot(C), K = [];
        W == null || W.forEach((oe) => K.push(new Date(oe.year, oe.month - 1, oe.day).getTime()));
        const v = new Date(Math.min(...K));
        return {
          year: v.getFullYear(),
          month: v.getMonth() + 1,
          day: v.getDate()
        };
      }
      if (y)
        return we(y);
      if (w && w > se.year)
        return { year: w, month: 1, day: 1 };
      if (E && E < se.year)
        return w ? { year: w, month: 1, day: 1 } : { year: E, month: 1, day: 1 };
    }
    return we(se);
  }, d = Object.keys(i.activeDate).length > 0 ? we(i.activeDate) : O(), M = ae.map((_) => /* @__PURE__ */ g(
    wn,
    {
      title: _.name,
      className: "Calendar__weekDay",
      children: _.short
    },
    _.name
  )), $ = (_) => {
    b({
      ...i,
      monthChangeDirection: _
    });
  }, R = () => {
    b({
      ...i,
      activeDate: at(d, i.monthChangeDirection),
      monthChangeDirection: ""
    });
  }, me = (_) => {
    const W = document.querySelector(_);
    W && setTimeout(() => {
      W.focus();
    }, 100);
  }, de = (_) => {
    b({
      ...i,
      activeDate: { ...d, month: _ },
      isMonthSelectorOpen: !1
    }), me(".Calendar__monthText");
  }, Q = (_) => {
    b({
      ...i,
      activeDate: { ...d, year: _ },
      isYearSelectorOpen: !1
    }), me(".Calendar__yearText");
  };
  return /* @__PURE__ */ Se(
    Dn,
    {
      className: he(["Calendar", r, `-${te ? "rtl" : "ltr"}`]),
      role: "grid",
      ref: I,
      children: [
        /* @__PURE__ */ g(
          an,
          {
            maximumDate: u == null ? void 0 : u.maxDate,
            minimumDate: u == null ? void 0 : u.minDate,
            activeDate: d,
            onMonthChange: $,
            onMonthSelect: ue,
            onYearSelect: re,
            monthChangeDirection: i.monthChangeDirection,
            isMonthSelectorOpen: i.isMonthSelectorOpen,
            isYearSelectorOpen: i.isYearSelectorOpen,
            locale: F,
            selectorStartingYear: w,
            selectorEndingYear: E
          }
        ),
        /* @__PURE__ */ g(
          mn,
          {
            isOpen: i.isMonthSelectorOpen,
            activeDate: d,
            onMonthSelect: de,
            maximumDate: u == null ? void 0 : u.maxDate,
            minimumDate: u == null ? void 0 : u.minDate,
            locale: F
          }
        ),
        /* @__PURE__ */ g(
          Sn,
          {
            isOpen: i.isYearSelectorOpen,
            activeDate: d,
            onYearSelect: Q,
            selectorStartingYear: w,
            selectorEndingYear: E,
            maximumDate: u == null ? void 0 : u.maxDate,
            minimumDate: u == null ? void 0 : u.minDate,
            locale: F
          }
        ),
        /* @__PURE__ */ g(_n, { className: "Calendar__weekDays", children: M }),
        /* @__PURE__ */ g(
          tn,
          {
            activeDate: d,
            value: e,
            selectorStartingYear: w,
            selectorEndingYear: E,
            monthChangeDirection: i.monthChangeDirection,
            onSlideChange: R,
            disabledDays: p,
            onDisabledDayError: t,
            minimumDate: u == null ? void 0 : u.minDate,
            maximumDate: u == null ? void 0 : u.maxDate,
            onChange: n,
            calendarTodayClassName: o,
            calendarSelectedDayClassName: c,
            locale: F,
            shouldHighlightWeekends: U,
            customDaysClassName: l,
            includeOutOfMonthDays: S,
            isQuickSelectorOpen: i.isYearSelectorOpen || i.isMonthSelectorOpen,
            allowedDates: ot(C),
            weekendDisabled: P
          }
        )
      ]
    }
  );
}, Mn = Mt.div`
  &.DatePicker__Input {
    ${({
  theme: {
    components: { datePicker: e }
  }
}) => Y(e.StyledCalendarPickerInput)};
  }
`, bn = Mt.div`
  &.DatePicker__Input--iconWrapper {
    ${({
  theme: {
    components: { datePicker: e }
  }
}) => Y(e.StyledIconWrapper)};
  }
`, Nn = rt.forwardRef(
  ({
    value: e,
    onChange: n,
    inputId: t,
    isDisabled: r = !1,
    inputPlaceholder: o,
    inputLabel: c,
    dateFormatOptions: p,
    inputClassName: y,
    autoSelect: D,
    editable: w,
    inputName: E,
    formatInputText: F,
    locale: U,
    success: l,
    isRequired: S,
    showRequiredIndicator: C,
    labelProp: P = {
      label: c,
      success: l,
      showRequiredIndicator: C
    },
    infoProp: I,
    trailingText: i,
    textSize: b,
    helperTextProp: u,
    inputState: V,
    hideClearButton: ee = !1,
    closeCalendar: N,
    ...ae
  }, te) => {
    const { from: se, to: ne, defaultPlaceholder: ue, defaultLabel: re } = $e(U), [O, d] = rt.useState(""), [M, $] = rt.useState(!1), R = Ce(e), me = Z(null), de = (fe = !0) => {
      if (F)
        return F();
      switch (R) {
        case De:
          return st(p, U, e, fe);
        case Ae:
          return Ht(p, U, se, ne, e);
      }
    }, Q = o || ue, _ = (P == null ? void 0 : P.label) || re, K = Wt().themeName === vt.FORD_PRO ? "cancelCloseFilled" : "cancelClose", v = !!(w && R === "SINGLE_DATE"), oe = () => {
      n == null || n(void 0), N == null || N();
    };
    return (() => {
      var fe, ke;
      return /* @__PURE__ */ g(
        Mn,
        {
          className: he([
            "DatePicker__Input",
            `DatePicker__Input--${b || "medium"}`,
            { "DatePicker__Input--disabled": r },
            { "DatePicker__Input--editable": v }
          ]),
          children: /* @__PURE__ */ g(
            Ft,
            {
              startAdornmentProp: {
                startAdornment: /* @__PURE__ */ g(
                  gt,
                  {
                    name: "calendar",
                    "aria-hidden": "true"
                  }
                )
              },
              endAdornmentProp: {
                endAdornment: !r && !ee && e && n ? /* @__PURE__ */ g(
                  bn,
                  {
                    className: "DatePicker__Input--iconWrapper",
                    onFocus: (a) => {
                      a.stopPropagation(), a.preventDefault();
                    },
                    children: /* @__PURE__ */ g(
                      gt,
                      {
                        name: `${K}`,
                        role: "button",
                        "aria-label": "Clear Button",
                        size: "s",
                        onClick: oe,
                        className: "DatePicker__Input--icon",
                        tabIndex: r ? -1 : 0,
                        onKeyDown: async (a) => {
                          var h;
                          (a.code === "Enter" || a.code === "Space") && (n(void 0), await d(""), (h = me.current) == null || h.focus());
                        }
                      }
                    )
                  }
                ) : void 0
              },
              "data-testid": "datepicker-input",
              readOnly: !v,
              ref: te,
              inputRef: me,
              id: t,
              type: "text",
              value: v && M ? O : de(),
              onFocus: (a) => {
                a.stopPropagation(), d(v && O || de(!1) || ""), $(!0);
              },
              onBlur: () => {
                d(""), $(!1);
              },
              onInput: (a) => {
                const f = a.target.value.replace(/[^0-9/]/g, "");
                if (d(Oe(f)), D && ct(f)) {
                  const { month: L, day: m, year: k } = Oe(f, !0);
                  n == null || n({ month: +L, day: +m, year: +k });
                }
              },
              onKeyDown: (a) => {
                if (a.key === "Enter") {
                  if (v && !D && ct(O)) {
                    const { month: h, day: f, year: L } = Oe(O, !0);
                    n == null || n({ month: +h, day: +f, year: +L });
                  }
                  N && (N == null || N()), a.stopPropagation();
                }
              },
              onKeyUp: (a) => {
                a.stopPropagation();
              },
              onClick: () => {
                !r && (N == null || N());
              },
              name: E,
              placeholder: Q,
              disabled: r,
              className: y,
              helperTextProp: u,
              inputState: V,
              isRequired: S,
              textSize: b,
              labelProp: {
                ...P,
                label: _
              },
              "aria-labelledby": `${(fe = u == null ? void 0 : u.defaultProp) == null ? void 0 : fe.id} ${(ke = u == null ? void 0 : u.secondaryProp) == null ? void 0 : ke.id}`,
              infoProp: { ...I },
              trailingText: i,
              ...ae
            }
          )
        }
      );
    })();
  }
), Ln = "CalendarInput", An = `
  @keyframes fadeCalendar {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeArrowFlipped {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
      transform: translateY(0) rotate(180deg);
    }
  }

  @keyframes fadeTextToCenter {
    to {
      opacity: 1;
      transform: translateX(-50%);
    }
  }

  @keyframes FadeContentToCenter {
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
`, Tn = x.div`
  &.DatePicker {
    ${({
  theme: {
    components: { datePicker: e }
  }
}) => Y(e.StyledDatePickerWrapper)};

    ${An};
  }
`, $n = x.div`
  &.DatePicker__calendarContainer {
    ${({
  theme: {
    components: { datePicker: e }
  }
}) => Y(e.StyledDatePickerCalenderContainer)};
  }
`, mr = Tt(
  ({
    value: e,
    isDisabled: n = !1,
    onChange: t,
    formatInputText: r,
    autoSelect: o = !0,
    inputPlaceholder: c,
    inputLabel: p,
    inputClassName: y,
    inputName: D,
    wrapperClassName: w,
    calendarClassName: E,
    calendarTodayClassName: F,
    calendarSelectedDayClassName: U,
    calendarPopperPosition: l,
    disabledDays: S,
    onDisabledDayError: C,
    minimumDate: P,
    maximumDate: I,
    selectorStartingYear: i,
    selectorEndingYear: b,
    locale: u = "en-US",
    shouldHighlightWeekends: V,
    customDaysClassName: ee,
    dateFormatOptions: N,
    isInvalid: ae,
    helperText: te,
    showErrorIcon: se,
    success: ne,
    fullwidth: ue = !1,
    isRequired: re = !1,
    showRequiredIndicator: O = re,
    textSize: d,
    includeOutOfMonthDays: M = !0,
    onBlur: $,
    accessibilityOptions: R = {},
    labelProp: me = {
      label: p,
      showRequiredIndicator: O,
      success: ne
    },
    infoProp: de,
    optionalText: Q,
    trailingText: _,
    allowedDates: W,
    weekendDisabled: K = !1,
    exceedOverflow: v = !1,
    editable: oe = !1,
    inputState: pe,
    helperTextProp: fe = {
      ...te && !ae && { defaultProp: { helperText: te } },
      ...ae && {
        secondaryProp: { helperText: te, state: "error" }
      }
    },
    hideClearButton: ke = !1,
    ...a
  }, h) => {
    var Re, j;
    const f = Z(null), L = xt({ label: "Date Picker" }), m = Z(null), k = Z(null), H = Z(Bt(Ln)), A = Z(!1), [T, J] = Ke(!1), [He, We] = Ke({}), { width: qe, height: Xe } = Et();
    let _e = e;
    typeof e == "string" && (_e = ct(e, !0) || "");
    let ye = pe || be.NONE;
    pe || (ye = ae ? be.ERROR : be.NONE);
    const G = fe;
    G && (G.defaultProp && !G.defaultProp.id && (G.defaultProp.id = `default_${H.current}_message_id`), G.secondaryProp && !G.secondaryProp.id && (G.secondaryProp.id = `secondary_${H.current}_message_id`));
    const ve = (s) => {
      k.current = s, typeof h == "function" ? h(s) : h && typeof h == "object" && (h.current = s);
    };
    le(() => {
      var ce;
      const s = Ce(e);
      if (s === Le)
        return;
      (s === De ? !T : !T && (e == null ? void 0 : e.from) && (e == null ? void 0 : e.to)) && ((ce = k == null ? void 0 : k.current) == null || ce.blur());
    }, [e, T]);
    const xe = (s) => {
      var ce, ge;
      if (s.persist(), !T)
        return;
      const q = (ce = m.current) == null ? void 0 : ce.contains(s.relatedTarget);
      A.current ? (A.current = !1, (ge = k == null ? void 0 : k.current) == null || ge.focus()) : q && s.relatedTarget && s.relatedTarget.focus(), $ && $(s);
    }, Ee = () => {
      A.current || J(!0);
    }, Ge = (s) => {
      const q = (B, z) => {
        var nt, ut, mt, ft, ht, pt;
        if (!B || !z)
          return !1;
        if (Object.keys(z).length === 2) {
          const X = z;
          return B.day >= (((nt = X == null ? void 0 : X.from) == null ? void 0 : nt.day) || 0) && B.month >= (((ut = X == null ? void 0 : X.from) == null ? void 0 : ut.month) || 0) && B.year >= (((mt = X == null ? void 0 : X.from) == null ? void 0 : mt.year) || 0) && B.day <= (((ft = X == null ? void 0 : X.to) == null ? void 0 : ft.day) || 0) && B.month <= (((ht = X == null ? void 0 : X.to) == null ? void 0 : ht.month) || 0) && B.year <= (((pt = X == null ? void 0 : X.to) == null ? void 0 : pt.year) || 0);
        }
        return B.day === (z == null ? void 0 : z.day) && B.month === (z == null ? void 0 : z.month) && B.year === (z == null ? void 0 : z.year);
      }, ce = (B, z) => !B || !z ? !1 : ge(B) < ge(z), ge = (B) => new Date(B.year, B.month - 1, B.day);
      let Me = !1;
      W && W.some((B) => q(s, B)) && (Me = !0);
      const Qe = ce(s, P), Be = ce(I, s), Ye = ((s == null ? void 0 : s.year) || 0) < i || ((s == null ? void 0 : s.year) || 0) > b, je = S == null ? void 0 : S.some((B) => q(s, B)), et = Qe || Be || Ye, Ie = [0, 6].includes(new Date((s == null ? void 0 : s.year) || 0, ((s == null ? void 0 : s.month) || 1) - 1, s == null ? void 0 : s.day).getDay());
      (W ? !Me : je || et || Ie && K) || t == null || t(s, St(s, N)), s === void 0 && (t == null || t(s, { formatted: "", default: "", native: null }));
    };
    $t(() => {
      var Ie, tt;
      if (!T || !m.current)
        return;
      const { left: s, width: q, height: ce, top: ge } = m.current.getBoundingClientRect(), { clientWidth: Me, clientHeight: Qe } = document.documentElement, Be = s + q > Me, Ye = s < 0, je = ge + ce > Qe, et = () => {
        const B = s + q - Me;
        if (!Be && !Ye)
          return "";
        const z = Math.abs(s);
        return Be ? `calc(50% - ${B}px)` : `calc(50% + ${Ye ? z : 0}px)`;
      };
      m.current.style.left = et(), (l === "auto" && je || l === "top") && ((tt = (Ie = m == null ? void 0 : m.current) == null ? void 0 : Ie.classList) == null || tt.add("-top"));
    }, [l, T]);
    const ze = (s) => {
      const q = Ce(s);
      t && t(s, St(s, N)), (q === De || q === Ae && (s != null && s.to)) && J(!1);
    }, Je = (s) => {
      switch (s.key) {
        case "Enter":
          J(!e);
          break;
        case "Escape":
          J(!1), A.current = !0;
          break;
      }
    };
    le(() => {
      var s;
      !T && A.current && ((s = k == null ? void 0 : k.current) == null || s.focus(), A.current = !1);
    }, [A, T]);
    const Ze = Rt("input", {
      ariaDisabled: n,
      ariaInvalid: ye === be.ERROR || ye === be.CAUTION,
      ariaRequired: re,
      ariaLabel: "MM / DD /YY",
      ...R
    });
    le(() => {
      if (T && v) {
        const s = l === "auto" || !l ? "bottom" : l;
        We(yt(k, m, s, "datepicker"));
        const q = () => {
          We(yt(k, m, s, "datepicker"));
        };
        return window.addEventListener("scroll", q, !0), () => {
          window.removeEventListener("scroll", q, !0);
        };
      }
    }, [T, v, qe, Xe, l]), le(() => {
      const s = (q) => {
        f.current && !f.current.contains(q.target) && T && J(!1);
      };
      return window.addEventListener("click", s), window.addEventListener("keyup", s), () => {
        window.removeEventListener("click", s), window.removeEventListener("keyup", s);
      };
    }, [T]);
    const Pe = () => {
      J(!T);
    };
    return /* @__PURE__ */ Se(
      Tn,
      {
        ref: f,
        onFocus: Ee,
        onBlur: xe,
        onKeyUp: Je,
        className: he([
          "DatePicker",
          w,
          `DatePicker--${d}`,
          { "DatePicker--fullwidth": ue },
          { "DatePicker--hasHelper": !!fe && T }
        ]),
        role: "presentation",
        ...L,
        children: [
          /* @__PURE__ */ g(
            Nn,
            {
              ref: ve,
              isDisabled: n,
              formatInputText: r,
              closeCalendar: Pe,
              value: _e,
              editable: oe,
              onChange: Ge,
              autoSelect: o,
              inputPlaceholder: c,
              inputLabel: p,
              success: ne,
              showRequiredIndicator: O,
              inputClassName: y,
              inputName: D,
              locale: u,
              dateFormatOptions: N,
              inputId: H.current,
              showErrorIcon: !T && se,
              isRequired: re,
              textSize: d,
              labelProp: {
                ...me
              },
              infoProp: { ...de },
              trailingText: Q || _,
              helperTextProp: T ? {
                defaultProp: {
                  id: (Re = G == null ? void 0 : G.defaultProp) == null ? void 0 : Re.id
                },
                secondaryProp: {
                  id: (j = G == null ? void 0 : G.secondaryProp) == null ? void 0 : j.id
                }
              } : G,
              inputState: ye,
              hideClearButton: ke,
              ...Ze,
              ...a
            }
          ),
          /* @__PURE__ */ g(
            bt,
            {
              "aria-live": "assertive",
              id: "hidden_message_id",
              children: /* @__PURE__ */ g(Pt, { ...G })
            }
          ),
          T && !n && /* @__PURE__ */ g(
            $n,
            {
              ref: m,
              className: he(["DatePicker__calendarContainer", { "DatePicker__calendarContainer--exceedOverflow": v }]),
              "data-testid": "calendar-container",
              role: "presentation",
              style: v ? He : {},
              children: /* @__PURE__ */ g(
                kn,
                {
                  value: _e,
                  onChange: ze,
                  calendarClassName: E,
                  calendarTodayClassName: F,
                  calendarSelectedDayClassName: U,
                  disabledDays: S,
                  onDisabledDayError: C,
                  minimumDate: P,
                  maximumDate: I,
                  selectorStartingYear: i,
                  selectorEndingYear: b,
                  locale: u,
                  shouldHighlightWeekends: V,
                  customDaysClassName: ee,
                  includeOutOfMonthDays: M,
                  allowedDates: W,
                  weekendDisabled: K
                }
              )
            }
          )
        ]
      }
    );
  }
);
export {
  mr as DatePicker
};
